module.exports = __webpack_public_path__ + "static/media/logo-horizontal-nyko-white.41a8ff31.svg";